import { useObjectDetailsDialog } from '~/components/Properties/ObjectDetailsDialog';
import ObjectInfoButton from '~/components/Properties/ObjectInfoButton';
import { PropertiesActions } from '~/components/Properties/PropertiesPanel';
import RegistrationProperties from '~/components/Properties/RegistrationProperties';
import ReviewStatus from '~/components/Structures/ReviewStatus';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';

/**
 * The (i) of a registration: its details dialog, headed by its name and its
 * approval status, with its properties, its DICOM tags and, when given, its
 * delete.
 */
export default function RegistrationInfoButton({
    name,
    registration,
    onDelete,
}: {
    /** The registration's name, which is PHI: the dialog masks it. */
    name: string;
    registration: RigidRegistration;
    onDelete?: () => void;
}) {
    const dialog = useObjectDetailsDialog();
    return (
        <ObjectInfoButton
            titleId="registration"
            name={name}
            dialog={dialog}
            badges={
                <ReviewStatus
                    status={registration.approvalStatus}
                    fontSize={10}
                    color="text.secondary"
                />
            }
            actions={<PropertiesActions onDelete={onDelete} />}
            dataset={registration.dicomParent.datasetWrapper}
        >
            <RegistrationProperties registration={registration} />
        </ObjectInfoButton>
    );
}
